/**
 * api 模块
 * @description production块内是线上接口
 *              else 块内是mock接口
 */

let api

if (process.env.NODE_ENV === 'production' || 1) {
    api = {
        //网页版登录
        //post,携带从websocket获取的token
        pc_web_login: '/pc/web_login',
        pc_web_logout: '/pc/web_logout',
        // 公开课
        // 获取微信config
        weixin_config: '/v/course_meta/weixin_index_parameter',
        // 获取微信服务器图片到七牛服务器
        weixin_upload_img: '',
        gkklist: '/v/gkk/course/course_list',
        course_about: '/v/gkk/course/course_about',
         // 加入课程
        course_study: '/v/gkk/course/course_study',
        learningplan: '/v/gkk/course/learning_plan_list',
        // 学习计划对比 计划详情
        learning_plan_choose: '/v/gkk/course/learning_plan_choose',
        // 支付
        payment_study_plan: '/v/gkk/course/payment_study_plan',
        learning_status: '/v/gkk/course/learning_status',
        learning_log: '/v/gkk/course/learning_log',
        // 章节学习
        section_detail: '/v/gkk/course/section_detail',
        // 学习章节详情
        learning_section_cards: '/v/gkk/course/learning_section_cards',
        // 本章节数量
        question_count: '/v/gkk/qa/question_count',
         // 学习章节问题
        problem_detail: '/v/gkk/course/problem_detail',
        // 学习进度记录
        view_record: '/v/gkk/course/view_record',
        // 章节学习完成
        section_finish: '/v/gkk/course/section_finish',
        // 预约课程
        reservation: '/v/gkk/course/reservation',
        // 优质公开课
        course_quality_list: '/v/gkk/course/course_quality_list',
        // 课程章节信息
        courseprofile : "/v/gkk/course/course_profile",
        // 学过的课程章节信息，比如用于提问的时候限定章节
        course_learned : "/v/gkk/course/course_learned",
        // 公开课问答列表
        gkkqas : "/v/gkk/qa/qa_list",
        // 公开课问答详情
        gkkqa_item : "/v/gkk/qa/question",
        // 收藏某个问题
        gkkqaitem_star_question : "/v/gkk/qa/collection/add_question",
        // 收藏别人的某个回答
        gkkqaitem_star_answer : "/v/gkk/qa/collection/add_answer",
        // 提问
        opencourse_ask : "/v/gkk/qa/create_question",
        // 修改提问
        opencourse_ask_edit : "/v/gkk/qa/edit_question",
        // 回答某个问题
        opencourse_qaitem_answer : "/v/gkk/qa/answer",
        // 获取我之前对某个问题的回答的内容
        gkkqa_item_myanswer : "/v/gkk/qa/my_answer",
        // 评论公开课问答详情中的某条别人的回答
        gkk_qaitem_comment_sommeanswer : "/v/gkk/qa/comment",
        // 删除公开课问答详情中自己的回答下的某条评论
        gkk_qaitem_comment_delete : "/v/gkk/qa/comment_delete",
        // 展开评论、获取评论共用接口
        gkk_qaitem_get_comment : "/v/gkk/qa/comments",
        // 我的各种券的数据
        mytickets: "/v/gkk/qa/my_tickets",
        // 对别人的回答赞踩
        thumbaction: "/v/gkk/qa/action_thumb",
        // 使用偷看券
        peekaction: "/v/gkk/qa/see_answer",
        // 使用邀请券
        inviteaction: "/v/gkk/qa/invite_answer",
        // 使用偷看券后获取教师的回答
        gkk_qaitem_answer_teacher: "/v/gkk/qa/get_see_answer",
        // 删除我的提出的问题，同时会删除它下面的所有回答等信息
        deleteqaitem: "/v/gkk/qa/delete_qa",
        // 删除我的回答
        delete_answeritem: "/v/gkk/qa/delete_answer",

        // 发现是否有新消息
        discover_new: '/v/discover/new',
        // 发现消息已阅
        discover_mark: '/v/discover/mark',

        // 我的课件、我的试卷、个人信息
        collection_list : "/v/course_meta/my_collections",
        deletecollection : "/v/course_meta/delete_collection",
        paper_list : "/v/quiz/my_papers",
        deletepaper : "/v/quiz/delete_paper",
        user_profile : "/v/course_meta/user_info",
        user_profile_edit : "/v/course_meta/edit_user_info",
        //高校名称list
        school_name_query : "/school_name/school_name_query",
        // 班级课程
        mycourse: "/v/course_meta/my_courses",
        //获取全部的课程列表——过滤归档班级的
        my_courses_top: '/v/course_meta/my_courses_top',
        edit_course: "/v/course_meta/edit_course",
        create_course: "/v/course_meta/create_course",
        exitClassroom : "/course_meta/quit_classroom",
        join_classroom : "/v/course_meta/join_classroom",
        manage_classroom_student:"/v/course_meta/manage_classroom_student",
        manage_classroom_teachinglogs:"/v/course_meta/manage_classroom_teachinglogs",
        manage_student:"/v/course_meta/manage_classroom_batchstudent",
        manage_role:"/v/course_meta/manage_role",
        manage_role_collaborator:"/v/course_meta/manage_role_collaborator",
        select_collection:"/v/course_meta/select_collection",
        select_collection2classroom:"/v/course_meta/select_collection2classroom",
        select_paper:"/v/quiz/select_paper",
        select_paper2classroom:"/v/quiz/select_paper2classroom",
        learning_lesson_detail:"/v/lesson/learning_lesson_detail",
        classroom_student_search: "/v/course_meta/classroom_student_search",
        //学生小结
        learning_lesson_detail_v2:"/v/lesson/learning_lesson_detail_v2",
        learning_lesson_detail_v3:"/api/v3/lesson-summary/student",
        learning_cards_detail:"/v/cards/learning_cards_detail",
        student_ppt:"/v/lesson/show_studentsPPT",
        student_ppt_v3:'/api/v3/lesson-summary/student/presentation',
        cards_feedback_reply:"/v/cards/cards_feedback_reply",
        cards_finished_list:"/v/cards/cards_finished_list",
        cards_viewer_list:"/v/cards/cards_viewer_list",
        teaching_cards_detail:"/v/cards/teaching_cards_detail",
        teacher_cards_answer_detail:"/v/cards/teacher_cards_problems_detail",
        teacher_quiz_detail:"/v/quiz/teacher_quiz_detail",
        teacher_quiz_finish_list:"/v/quiz/quiz_finish_list",
        teacher_quiz_checked_detail:"/v/quiz/quiz_checked_detail",
        teacher_quiz_answer_detail:"/v/quiz/teacher_quiz_problems_detail",
        teacher_quiz_score_detail:"/v/quiz/teacher_quiz_score_detail",
        teacher_PPT:"/v/lesson/show_teacherPPT",
        teacher_PPT_one:"/v/lesson/show_teacherslide_info",
        teacher_slideproblem_detail:"/v/lesson/show_teacherslideproblem_detail",
        lesson_subjective_problem_result_list: "/v/lesson/subjective_problem_result_list",
        subjective_problem_unfinished_list: "/v/lesson/subjective_problem_unfinished_list",
        subjective_problem_teacher_scorev2: "/v/lesson/subjective_problem_teacher_scorev2",
        teacher_slideproblem_resultdetail:"/v/lesson/show_teacherslideproblem_resultdetail",
        lesson_detail_teacher_presentation:"/v/lesson/lesson_detail_teacher_presentation",
        config_presentation: "/v/lesson/config_presentation",
        web_ppt_config: "/pc/web_ppt_config",

        //【课堂】【教师+学生】获取主观题题目回答详情
        GET_LESSON_PROBLEM_RESULT_DETAIL: '/v/lesson/new_get_subj_problem_result_detail/',

        // 旁听生加入班级

        audit_classroom: "/edu_admin/audit_classroom/",

        // 课程小结 start
        teaching_lesson_detail:"/v/lesson/teaching_lesson_detail",
        teaching_lesson_detail_additional: "/v/lesson/teaching_lesson_detail_additional",
        lesson_problem_statistics: "/v/lesson/lesson_problem_statistics",
        teaching_lesson_rank: "/v/lesson/teaching_lesson_student_score_list",
        teaching_lesson_personal: "/v/lesson/teaching_lesson_student_score_detail",
        random_name_list: "/v/lesson/random_name_list",
        lesson_not_participant_list: "/v/lesson/lesson_not_participant_list_new",
        teaching_lesson_members: "/v/lesson/teaching_lesson_participant_list_new",
        view_live_list: "/v/lesson/view_live_list",
        teaching_lesson_slides: "/v/lesson/teaching_lesson_slides_unknow_count_list",
        teaching_lesson_slide_detail: "/v/lesson/teaching_lesson_slide_students_unknow_list",
        teaching_lesson_problems: "/v/lesson/teaching_lesson_problem_list",
        teaching_lesson_problem_detail: "/v/lesson/teaching_lesson_problem_students_list",
        get_subj_result_score_detail: '/v/lesson/get_subj_result_score_detail/',
        // (教师端) 修改主观题打分比例
        edit_subj_problem_score_proportion:  '/v/lesson/edit_subj_problem_score_proportion',
        // 课程小结 end
        lesson_danmu_detail:"/v/lesson/danmu_detail",
        mystore:"/v/gkk/collection/mycollection",
        mystore_create_tag:"/v/gkk/collection/create_tag",
        mystore_delete_tag:"/v/gkk/collection/delete_tag",
        //收藏中投稿标签增删
        mystore_create_tougao_tag:"/v/api/tougao/create_tag",
        mystore_delete_tougao_tag:"/v/api/tougao/delete_tag",
        publish_paper:"/v/quiz/publish_paper2classroom",
        publish_collection:"/v/course_meta/publish_collection2classroom",
        message_task:"/v/gkk/msg/tasks",
        message_notice:"/v/gkk/msg/notifications",
        message_notice_new:"/v/gkk/msg/tasks_and_notifications",
        message_fans:"/v/gkk/msg/follows",
        message_mark:"/v/gkk/msg/mark",
        message_new:"/v/gkk/msg/new",
        // 小金库 start
        bank_balance: "/pay/inner",
        generate_order: "/pay/mp/order",
        bank_query: "/pay/query",
        // 小金库 end
        members_profile:"/api/op/web_get_classroom_members_profile",
        platform_node:"/api/op/node_proxy",
        classroom_students:"/api/op/web_get_classroom_members",
        platform_exp_reminder:"/api/op/exp_reminder",
        //专业版身份绑定
        pro_getBindSchool:"/edu_admin/get_university_info/",
        bind_user_number:"/edu_admin/bind_user_number/",
        unbind_user_number:"/edu_admin/unbind_user_number/",
        get_verify_info:"/edu_admin/verify/get_verify_basic_info/",
        get_verify_code:"/edu_admin/verify/get_verify_code/",
        get_cas_university_bind_hint: "/edu_admin/get_cas_university_bind_hint/",
        get_school_info:'/edu_admin/get_single_university_info/',
        //教师查看投稿
        teacher_tougao_list: "/v/api/tougao/teacher/list",
        teacher_tougao_collect:"/v/api/tougao/collect",
        teacher_tougao_collect_cancel:"/v/api/tougao/collect_cancel",
        student_tougao_list:"/v/api/tougao/student/list",
        student_tougao_list_v3:'/api/v3/lesson-summary/tougao',
        //预约发布
        publish_appointment: "/v/course_meta/publish_appointment/",
        delete_publish_appointment: "/v/course_meta/delete_publish_appointment/",
        edit_publish_appointment: "/v/course_meta/edit_publish_appointment/",

        // 异步创建发布课件或试题
        async_publish_appointment: "/v/course_meta/async_publish_appointment/",
        // 创建发布课件或试题后轮询进度
        publish_appointment_schedule: "/v/course_meta/publish_appointment_schedule/",

        //批量导出EXCEL
        get_export_activities:"/v/course_meta/get_export_activities/",
        generate_data_export:"/v/course_meta/generate_data_export/",
        query_export_task_state:"/v/course_meta/query_export_task_state/",
        //打印获取教师、班级信息
        get_event_extra_info:"/api/op/get_event_extra_info?event_id=",
        //群发公告
        publish_notice:"/v/link/classroom_info",
        topublish_notice:"/v/link/publish_notice2classroom",
        topublish_notice_v2:'/v/discussion/v2/topics/',
        notice_view:"/v/link/notice_info",
        notice_view_notice_up:'/v/discussion/v2/announcement/{id}/',
        get_download_leaf_attachment: '/v/course_meta/v2/university/settings',
        forum_top:'/v/discussion/v2/topic/{forum_id}/top/',
        delete_notice:"/v/link/delete_notice",
        delete_announcement: '/v/discussion/v2/topic/{id}/',
        notice_ready_static:"/v/link/notice_view_list",
        notice_ready_static_new: '/v/discussion/v2/announcement/read',
        //是否需要签署诚信协议
        class_agreement: "/c27/online_courseware/classroom_agreement/detail/",
        //签署协议
        sign_class_agreement: '/c27/online_courseware/classroom_agreement/sign/',
        //公告
        announcement:{
            //公告下评论列表
            'get_comment_list': '/v/discussion/v2/comment/list/{id}/',
            //回复公告
            'reply_comment':'/v/discussion/v2/comment/',
            // 回复公告评论
            'reply_notice_comment':'/v/discussion/v2/reply/comment/',
            // 回复评论的评论
            'reply_reply':'/v/discussion/v2/reply/reply/',
            'do_digg': '/v/discussion/v2/comment/{id}/liked/',
            'delete_comment':'/v/discussion/v2/comment',
            'delete_reply': '/v/discussion/v2/reply/reply/'
        },
        //修改头像
        edit_user_avatar:"/v/course_meta/edit_user_avatar",

        // 习题集

        // 习题集课程列表
        problemset_course_list: "/v/problem/my_problem_list",
        // 课程活动列表
        problemset_course_activities: "/v/problem/all_problem_list",
        // 课程活动错误列表
        problemset_error_problems: "/v/problem/error_problem_list",
        // 课程活动加星问题列表
        problemset_star_problems: "/v/problem/star_problem_list",

        // 活动问题列表
        problemset_cards_problems: "/v/problem/cards_problem_list",
        problemset_lesson_problems: "/v/problem/lesson_problem_list",
        problemset_quiz_problems: "/v/problem/quiz_problem_list",

        // 问题收藏
        problemset_add_star: "/v/problem/add_star",
        problemset_cancel_star: "/v/problem/cancel_star",

        // 问题记录笔记
        problemset_add_note: "/v/problem/add_modify_note",

        // 教师查看课件详情
        teacher_cards_detail: "/v/cards/cards_detail_teacher_slides/",

        //设置语言
        set_lang_en: "/v/user/set_language/en",
        set_lang_zh_cn: "/v/user/set_language/zh_cn",
        // 讨论区帖子
        get_post: "/v/discussion/one_topic_fetch",
        get_post_v2: "/v/discussion/v2/web/topic",
        reply_post: "/v/discussion/reply_create_with_post",
        reply_post_v2: "/v/discussion/v2/web/reply",
        get_post_comments: "/v/discussion/comment_fetch",
        get_post_comments_v2: "/v/discussion/v2/web/comment/list",
        get_post_comment: "/v/discussion/one_comment_fetch",
        //回复列表
        get_post_comment_v2: "/v/discussion/v2/web/comment/list",
        // 帖子详情
        get_topic_details_v2: '/v/discussion/v2/web/reply',
        do_digg: "/v/discussion/like_up",
        do_digg_v2: "/v/discussion/v2/web/like",
        cancel_digg: "/v/discussion/like_cancel",
        cancel_digg_v2: '/v/discussion/v2/web/like',
        get_digg_list: "/v/discussion/like_user_list",
        get_digg_list_v2: "/v/discussion/v2/web/like/list",
        del_post: "/v/discussion/topic_delete",
        del_post_v2: "/v/discussion/v2/web/reply",
        // 删除评论和评论回复
        del_post_reply: "/v/discussion/reply_delete",
        del_post_reply_v2: "/v/discussion/v2/web/reply",
        //讨论区
        // post_dicssuion: "/v/discussion/topic_create",
        // discussion_topic_fetch: "/v/discussion/classroom_topic_fetch",
        // discussion_like_up: "/v/discussion/like_up",
        // discussion_like_cancel: "/v/discussion/like_cancel",
        // topic_edit: "/v/discussion/topic_edit",
        // activity_topic_create: "/v/discussion/activity_topic_create",

        //课件替换接口
        activity_topic_create_v2:'/v/discussion/v2/web/topic',

        // 讨论区替换成学堂云
        get_topic_list: "/v/discussion/v2/topics/",
        post_topic_list: "/v/discussion/v2/topics/",
        edite_topic_list: '/v/discussion/v2/topics/',
        topic_liked: "/v/discussion/v2/topic/{topic_id}/liked/",
        comment_liked: "/v/discussion/v2/comment/{comment_id}/liked/",
        get_comment_list: "/v/discussion/v2/comment/list/{topic_id}/",
        get_comment_detail: "/v/discussion/v2/topic/detail/{topic_id}/",
        get_replys_list: "/v/discussion/v2/reply/list/{comment_id}/",
        get_comment: "/v/discussion/v2/comment/",
        send_comment: "/v/discussion/v2/comment/",
        reply_comment: "/v/discussion/v2/reply/comment/",
        reply_replay: "/v/discussion/v2/reply/reply/",
        reply_list: "/v/discussion/v2/reply/list/{reply_id}/",
        del_topic: "/v/discussion/v2/topic/{topic_id}/",
        del_comment: "/v/discussion/v2/comment/",
        del_reply: "/v/discussion/v2/reply/reply/",
        get_topic_liked: "/v/discussion/v2/liked/user/list/",
        get_comment_liked: "/v/discussion/v2/liked/user/list/",

        // 上传图片
        upload :'/c27/online_courseware/service/upload/',

        //新教学日志
        classroom_logs: "/v/course_meta/classroom_logs",
        manage_teaching_activity: "/v/course_meta/manage_teaching_activity",  //编辑标题和删除的老接口
        check_permission_manage_teaching_activity: "/v/course_meta/check_permission_manage_teaching_activity",  //检查协同教师权限的老接口
        on_lesson_courses: "/v/course_meta/on_lesson_courses",     //正在上课
        get_upcoming_exam: "/v/rain_exam/get_upcoming_exam/",  // 正在进行的考试
        send_mails_to_teacher: "/send_mails_to_teacher", // 发送数据到邮箱
        get_reset_leaf: "/mooc-api/v1/lms/learn/course/reset_leaf", //获取重置作业时间
        get_classroom_info: "/v2/api/web/classrooms", //获取班级信息
        on_lesson_upcoming_exam: "/api/v3/classroom/on-lesson-upcoming-exam", // 获取正在上的班级以及即将开始的考试

        //课件、试卷文件夹
        own_collections:"/v/cards/own_collections",
        learned_cards:"/v/cards/learned_cards",
        own_papers:"/v/quiz/own_papers",
        learned_quiz:"/v/quiz/learned_quiz",
        change_directory:"/api/cop/change_directory",

        // 私信相关
        get_user: "/v/course_meta/fetch_user_info",
        get_user_new: "/v/course_meta/fetch_user_info_new",
        get_users_avatar: "/v2/api/web/userinfo",
        send_letter: "/v/course_meta/send_letter",
        test: "",

        // 预习详情页支持查看每个学生习题总得分
        cards_status_list: '/v/cards/cards_status_list',
        // 预习详情页支持查看单个学生详情
        student_cards_detail: '/v/cards/student_cards_detail',
        // 教师试卷详情页支持查看每个学生答卷情况
        teacher_quiz_result_list: '/v/quiz/teacher_quiz_result_list',
        // 教师试卷详情页支持查看每个学生答卷情况-学生详情
        student_quiz_detail: '/v/quiz/student_quiz_detail',
        //获取用户当前语言设置
        get_current_language: "/v/user/get_current_language",
        // 获取实验详情
        web_get_event_detail: "/api/op/web_get_event_detail/",

        // 截屏列表
        get_screenshot_list: "/v/lesson/file_sharing/get_lesson_share_list/",
        get_screenshot_list_v3: '/api/v3/lesson-summary/file-sharing',

        get_group_team_detail_v3: '/api/v3/group/team/detail',
        // 直播回放
        get_lesson_timeline: "/v/lesson/get_lesson_replay_timeline/",
        get_lesson_info: "/v/lesson/get_lesson_replay_content/",
        get_board_track: "/v/lesson/file_sharing/get_board_track",
        // get_board_track: "/mock/get_board_track.json",
        // 学生观看回放
        view_live: "/v/lesson/view_live",
        // 删除直播记录
        delete_live: '/v/lesson/live/delete',
        // 查询是否有转存权限
        get_permissions: '/api/open/plug/audiovideo/permissions',
        // 查询用户的空间大小
        get_user_space: '/api/open/yunpan/userspace/detail',
        // 转存回放段落
        save_live: '/api/open/yunpan/lesson/live/save-as',
        // 获取直播回放下载地址
        download_live: '/v/lesson/live/download',
        // 获取是否是会员
        get_vip_status: '/v/course_meta/vip/',
        // 返回云盘使用权限
        get_cloud_permission: '/api/open/yunpan/lesson/live/permission',
        // 转存回放段落
        save_live5: '/api/open/yunpan/lesson/live5/save-as',
        // 获取直播回放下载地址
        download_live5: '/v/lesson/live/download5',
        // 直播回放隐藏
        change_replay_status: '/v/lesson/change_replay_status',

        // 停服务通知
        hole_service_notice: "/pc/hole_service_notice/",
        // 手机号绑定强制弹窗条件判断
        force_bind_status: "/pc/force_bind_status",
        // 是否已绑定手机号
        is_bind_phone: "/pc/is_bind_phone",
        // 用户绑定手机号
        bind_phone: "/pc/bind_phone",
        // 发送短信验证码接口
        send_sms_code: "/pc/send_sms_code",

        // 新的钱包充值提现接口
        payment_proxy: '/v/payment/node_proxy',

        // h5,小程序,新web-获取阅读并同意用户内容版权协议
        get_agreement: '/train_platform/v1/rain-user/agreement/',
        set_agreement: '/train_platform/v1/rain-user/agreement/',

        // 学生表现页接口
        behavior_tag: {
            // 学生课堂表现加分备注页
            student_about: "/v/lesson/behavior_tag/student_about",
            // 修改学生的签到状态
            change_participate: "/v/lesson/behavior_tag/change_participate",
            // 修改学生的表现加分值
            change_score: "/v/lesson/behavior_tag/change_score",
            // 搜索学生
            search_classroom_student: "/v/lesson/behavior_tag/search_classroom_student",
            // 新增标签
            create_tag: '/v/lesson/behavior_tag/created',
            // 给学生添加标签
            bind_student: "/v/lesson/behavior_tag/bind_student",
            // 老师删除标签
            deleted_tag: "/v/lesson/behavior_tag/deleted"
        },

        // 学生课后小结取消/收藏课件
        post_studentlessonslide_tag: "/v/lesson/post_studentlessonslide_tag",
        post_studentlessonslide_tag_v3: "/api/v3/lesson-summary/tag",

        // 通用账号密码设置
        user_account_setting: {
            // 【通用】获取用户账号设置状态
            get_user_bind_status: "/pc/register/get_user_bind_status/",
            // 【邮箱】绑定邮箱
            bind_email: "/pc/register/bind_email/",
            // 【邮箱】发送绑定邮箱验证码
            send_email_code: "/pc/register/send_email_code/",
            // 设置密码
            set_password: "/pc/register/set_password/",
            // 【加密】获取密码加密公钥
            get_pws_public_key: "/pc/register/get_pws_public_key/",
            // 是否已绑定手机号
            is_bind_phone: "/pc/is_bind_phone",
            // 用户绑定手机号
            bind_phone: "/pc/bind_phone",
            // 发送短信验证码接口
            send_sms_code: "/pc/send_sms_code",
            // 发送手机验证码登录验证码-----用于忘记密码中获取验证码 || 【手机登录】发送手机验证码登录验证码
            send_sms_login_code: "/pc/login/send_sms_login_code/",
            // 验证短信验证码是否正确
            verify_sms_code: "/pc/verify_sms_code/",
            // 通用登录】邮箱/手机号密码登录+手机号验证码登录
            verify_pwd_login: "/pc/login/verify_pwd_login/",
            // 忘记密码重新设置密码
            set_forgotten_password: "/pc/set_forgotten_password/",
            // 是否绑定腾讯会议账号
            check_bind: '/api/v3/lesson/meeting/tencent/check-bind',
            // 新的绑定+校验接口
            check_phone_number_bind: "/api/v3/user/check-phone-number-bind",
            update_phone_number: "/api/v3/user/update-phone-number",
            // 账号合并
            merge_account: '/api/v3/user/mergeAccount',
            // 获取选课列表
            get_all_course_list: "/v/course_meta/all_course_list",
            bind_email_for_user: "/pc/register/bind_email_for_user/",
        },
        // 行政通知
        notice: {
            // get获取用户已发布的行政通知列表
            "get_notice_list": "/edu_admin/admin_notice/list/",
            // 获取可选择发送范围
            "get_notice_area": "/edu_admin/admin_notice/areas/",
            // 根据选择发送范围获取发送人员名单
            "get_notice_users": "/edu_admin/admin_notice/users/",
            // 保存行政通知并处于预发布/预审核状态
            "post_notice_info": "/edu_admin/admin_notice/save/",
            // 编辑行政通知
            "edit_notice_info": "/edu_admin/admin_notice/edit/",
            // 生成或者刷新二维码
            "get_notice_qrcode": "/edu_admin/admin_notice/qr_code/",
            // 发布行政通知
            "post_notice_publish": "/edu_admin/admin_notice/publish/",
            // 查看行政通知
            "get_notice_publish": "/edu_admin/admin_notice/detail/",
            // 删除行政通知
            "delete_notice_publish": "/edu_admin/admin_notice/delete/",
            // 设置审核信息
            "post_notice_setting": "/edu_admin/admin_notice/settings/",
            // 轮询用户是否扫码成功
            "get_notice_scan": "/edu_admin/admin_notice/check_scan/",
            // 审核通知
            "post_notice_audit": "/edu_admin/admin_notice/audit/",
        },
        // 课程设置页
        course_setting: "/v/course_meta/v2/course/setting",
        // 课程简介
        course_intro: "/v/course_meta/v2/course/intro",
        // 编辑课程
        course_edit: "/v/course_meta/v2/course/edit",
        // 编辑班级
        classroom_edit: "/v/course_meta/v2/classroom/edit",
        // 删除课程提示
        course_del_confirm: "/v/course_meta/v2/course/del_confirm",
        // 删除班级确认
        classroom_del_confirm: "/v/course_meta/v2/classroom/del_confirm",
        // 删除班级
        classroom_delete: "/v/course_meta/v2/classroom/delete",
        // 归档班级
        archive_classroom: "/v/course_meta/archive_course",
        // 取消归档操作
        cancel_archive_course: '/v/course_meta/cancel_archive_course',
        // 删除课程
        course_delete: "/v/course_meta/delete_course",
        // 创建班级
        classroom_create: "/v/course_meta/v2/classroom/create",
        // 班级设置页
        classroom_setting: "/v/course_meta/v2/classroom/setting",

        // 清华校友会发起绑定
        taaStart: "/taa/start",
        // 清华校友会轮训绑定状态
        taaPolling: "/taa/polling",

        // 成员管理新接口
        member_manage: {
            // 查询班级的主讲老师、协助老师、助教列表
            "teacher_assistants": "/api/open/classroom/member/teacher_assistants",
            // 分页查询班级的学生信息
            "page_students": "/api/open/classroom/member/page-students",
            // 查看班级用户个人信息
            "user_info": "/api/open/classroom/member/user-info",
            // 根据学号或姓名模糊搜索班级的学生信息
            "search_students": "/api/open/classroom/member/search-students",
            // 邀请学生-查看班级二维码
            "classroom_barcode": "/api/open/classroom/member/classroom-barcode",
            // 编辑学生的班级名片信息
            "classroom_card": "/api/open/classroom/member/change/classroom-card",
            // 查询班级的黑名单
            "blacklist": "/api/open/classroom/member/blacklist",
            // 删除班级学生
            "remove_student": "/api/open/classroom/member/remove-student",
            // 批量加入黑名单
            "join_blacklist": "/api/open/classroom/member/join-blacklist",
            // 删除班级成员
            "removed": "/api/open/classroom/member/removed",
            // 提拔班级用户的班级身份
            "promoted": "/api/open/classroom/member/promoted",
            // 降级班级用户的班级身份
            "demoted": "/api/open/classroom/member/demoted",
            // 添加班级用户
            "add": "/api/open/classroom/member/add",
            // 批量解除黑名单
            "remove_blacklist": "/api/open/classroom/member/remove-blacklist",
            // 查看班级用户班级身份
            "classroom_role": "/api/open/classroom/member/classroom-role",
            // 基础版本搜索班级用户信息（老师、助教、学生）
            "basic_search_members": "/api/open/classroom/member/basic-search-members",
            // 分页查询班级的用户信息，比如协同等
            "page_members": "/api/open/classroom/member/page-members",
            // 查询班级信息
            "classroom_info": "/api/open/classroom/member/classroom-info",
            // 查询当前用户角色
            "member_classroom_role": "/api/open/classroom/member/classroom-role",
        },
        // 新试卷封面页接口
        examcover: {
            // 试卷封面
            cover: "/v/exam/cover",
            // 获取跳转token
            get_tocken: "/v/exam/gen_token",
            // 结课后是否能继续学习
            classroom_extra_info: '/v/course_meta/v2/classroom/extra-info',
        },
        // 考试小结
        exam: {
            // 获取班级信息
            classroom_info: '/v/course_meta/classroom_info',
            basic: "/v/exam/stats/basic",
            distribution: "/v/exam/stats/distribution",
            users: "/v/exam/stats/user",
            del: "/v/rain_exam/delete_exam_activity/",
            //用户密码校验
            vertify_password: '/c27/api/exam/verify_publish_exam_password/',
        },
        // 学校绑定
        mystoreAllApi: {
            sms_code: '/edu_admin/account/bind/login/sms_code',
            bind_sms: '/edu_admin/account/bind/login/sms',
            get_university_info: '/edu_admin/get_university_info/',
            register_sms_code: '/edu_admin/account/register/sms_code',
            register_phone: '/edu_admin/account/register/phone',
            //清华比赛--注册账号--学校列表
            external_university_list:"/train_platform/v1/external_university_list/",
            get_all_env_uv_list: '/edu_admin/get_all_env_uv_list/',
            tempqrcode: '/wechat/wxapi/tempqrcode',
            get_uv_qrcode: '/edu_admin/get_uv_qrcode/', // {uv_id}/{env}
            get_user_phone_number: '/edu_admin/get_user_phone_number/',
            bind_user_number_add_info: '/edu_admin/bind_user_number_add_info/',
            get_one_university_info: '/edu_admin/get_one_university_info/',
            get_user_info: '/edu_admin/get_user_info/',
            send_code: '/edu_admin/account/bind/login/send_code',
            bind_by_code: '/edu_admin/account/bind/login/code',
            // k12相关
            k12_check_user: '/edu_admin/check_k12user_number/',
            k12_bind_user: '/edu_admin/bind_k12user_number/',
            k12_verify_children: '/edu_admin/account/register/weixin/verify-children',
            k12_register_parent: '/edu_admin/account/register/weixin/bind-children',
            k12_get_school_platform:'/edu_admin/parents/children/weixin/school-platform/',
        },

        // 成绩单相关
        transcript: {
            get_status: '/v/course_meta/transcript/classroom/open/status',
            get_tags: '/v/course_meta/all/etag'
        },


        // 云雨教学活动打通
        cloud: {
            // 获取章节批量发布动态详情
            get_pub_news: '/c27/online_courseware/xty/kls/pub_news/{news_id}/',
            // 章节叶子节点详情
            get_leaf_info: '/mooc-api/v1/lms/learn/leaf_info/{classroom_id}/{leaf_id}/',
            leaf_level_info: "/edu_admin/leaf_level_info/",
        },

        teacher_v3: {
            lesson_summary_teacher: '/api/v3/lesson-summary/teacher', // 课后小结-基本信息
            lesson_summary_teacher_students: '/api/v3/lesson-summary/teacher/students', // 课后小结-学生列表
            update_presentation_config: '/api/v3/lesson-summary/update-presentation-config', // （老师）课后更改设置PPT查看范围
            update_config: '/api/v3/user/update-config', // TODO: 全局设置PPT查看范围
            teacher_presentation: '/api/v3/lesson-summary/teacher/presentation', // （老师）课后小结-课件信息
            on_lesson_courses: '/api/v3/classroom/on-lesson', // 正在上课
            subj_list: '/api/v3/lesson-summary/subj-list',  // 主观题列表
            subj_result_list: '/api/v3/lesson-summary/subj-result-list', // （老师）主观题回答列表
            subj_grade: '/api/v3/lesson-summary/subj-grade', // 主观题打分
            danmu: '/api/v3/lesson-summary/danmu', // 弹幕列表
            tougao: '/api/v3/lesson-summary/tougao', // 投稿列表
            roll: '/api/v3/lesson-summary/roll', // 随机点名列表
            file_sharing: '/api/v3/lesson-summary/file-sharing', // 截图分享分享
            collect: '/api/v3/lesson-summary/tag', // 课下不懂收藏
            student_info: '/api/v3/lesson-summary/student-info', // 学生课堂表现详情
            assess_student_about: '/api/v3/lesson-assess/student/about', // 学生课堂表现加分和标签
            assess_score_changed: '/api/v3/lesson-assess/score/changed', // 学生课堂表现加分变更
            assess_tag_created: '/api/v3/lesson-assess/tag/created', // 学生课堂表现老师添加标签
            assess_tag_bind_student: '/api/v3/lesson-assess/tag/bind_student', // 学生课堂表现老师变更选中标签
            assess_tag_deleted: '/api/v3/lesson-assess/tag/deleted', // 学生课堂表现老师删除标签
            teacher_checkin: '/api/v3/lesson-summary/checkin', // 课下修改学生签到状态
            fetch_student_detail: '/api/v3/lesson-summary/student/detail', // 获取学生跟人详情
            problem_histogram: '/api/v3/lesson-summary/problem-histogram', // 客观题柱状图数据、红包列表
            problem_choice_detail: '/api/v3/lesson-summary/problem-choice-detail', // 客观题选项选择分布
            fill_blank_result: '/api/v3/lesson-summary/fill-blank-result', // 填空题学生信息以及作答详情
            regrade_blank: '/api/v3/lesson-summary/regrade-blank', // 填空题改判
            students_search: '/api/v3/lesson-summary/teacher/students/search', // 搜索学生
        },
        student_v3: {
            lesson_summary_student: '/api/v3/lesson/summary/student', // 课后小结-基本信息
            // 直播回放
            get_replay: '/api/v3/lesson-summary/replay',
            // （学生）直播-观看直播回放
            view_replay: '/api/v3/lesson-summary/live/view',
            // 删除直播记录
            delete_live: '/api/v3/lesson-summary/replay/delete',
            // 拉取课件数据
            get_presentation: '/api/v3/lesson-summary/student/presentation',
            // 视频打点
            heartbeat: '/video-log/heartbeat/'
        },
        evaluation_list: '/api/evaluation/teaching/universities',
        redirectToEvaluation: '/api/evaluation/teaching/redirectTo',
        getCheckSetUpEvaluation: "/api/evaluation/teaching/checkSetUpEvaluation",
        // 账号注销-查询
        get_account_status: '/pc/get_close_account_info',
        // 账号注销-撤回
        cancel_close_account: "/pc/cancel_close_account",
        // 师德师风承诺书
        get_user_apply_judge: '/train_platform/v1/cert/user_tc8/judge/',
        get_cert_user_info: '/train_platform/v1/cert/user_tc8/info/',

        k12:{
          // k12获取当前是否是家长变身后的登录状态
          getUserInfo:'/edu_admin/parents/children/weixin/is-parent/'
        },
        get_discovery_link: '/c27/online_courseware/find_page_link/',
        graph_convert: '/c27/online_courseware/instance/graph/convert/',
        get_graph_menu: '/mooc-api/v1/lms/kg/student_learn_chapter/',
        knowledge_graph_jump_leaf:'/train_platform/v1/knowledge_graph/{graph_id}/jump_leaf/{classroom_id}/',
    }
} else {
    api = {
        //公告
        announcement:{
            //公告下评论
            'get_comment_list': 'http://apimock.xuetangx.com/mock/619/v/discussion/v2/comment/list/{id}/',
            //回复公告
            'reply_comment':'http://apimock.xuetangx.com/mock/619/v/discussion/v2/reply/comment/',

            // 回复公告评论
            'reply_notice_comment':'http://apimock.xuetangx.com/mock/619/v/discussion/v2/reply/comment/',
            // 回复评论的评论
            'reply_reply':'http://apimock.xuetangx.com/mock/619/v/discussion/v2/reply/reply/',
            'do_digg': 'http://apimock.xuetangx.com/mock/619/v/discussion/v2/comment/{id}/liked/',
            'delete_comment':'http://apimock.xuetangx.com/mock/619/v/discussion/v2/comment'
        },
        // 公开课
        gkklist: '/mock/gkklist.json',
        course_about: '/mock/aboutcourse.json',
        // 加入课程
        course_study: '/mock/aboutcourse.json',
        learningplan: '/mock/learningplan.json',
        // 学习计划对比
        learning_plan_choose: '/mock/learningplan_diff.json',
        payment_study_plan: '/mock/learningplan_diff.json',
        learning_status: '/mock/learning_status.json',
        learning_log: '/mock/learning_log.json',
        // 章节学习
        section_detail: '/mock/learning.json',
         // 学习进度记录
        view_record: '/mock/learning.json',
        // 学习章节详情
        learning_section_cards: '/mock/learning_cards.json',
        // 本章节数量
        question_count: '/mock/learning_problem.json',
        // 学习章节问题
        problem_detail: '/mock/learning_problem.json',
        // 章节学习完成
        section_finish: '/mock/learningcompletion.json',
        // 优质公开课
        course_quality_list: '/mock/opencourse_quality_list.json',
        courseprofile : "/mock/courseprofile.json",
        // 学过的课程章节信息，比如用于提问的时候限定章节
        course_learned : "/mock/courseprofile.json",
        gkkqas : "/mock/gkkqas.json",
        gkkqa_item : "/mock/gkkqa_item.json",
        gkkqaitem_star_question : "/mock/gkkqaitem_star.json",
        gkkqaitem_star_answer : "/mock/gkkqaitem_star.json",
        opencourse_ask : "/mock/opencourse_ask.json",
        opencourse_ask_edit : "/mock/opencourse_ask.json",
        opencourse_qaitem_answer : "/mock/opencourse_qaitem_answer.json",
        gkkqa_item_myanswer : "/mock/gkkqa_item_myanswer.json",
        gkk_qaitem_comment_sommeanswer : "/mock/gkk_qaitem_comment_sommeanswer.json",
        gkk_qaitem_comment_delete : "/mock/gkk_qaitem_comment_delete.json",
        gkk_qaitem_get_comment : "/mock/gkk_qaitem_get_comment.json",
        mytickets: "/mock/mytickets.json",
        thumbaction: "/mock/thumbaction.json",
        peekaction: "/mock/peekaction.json",
        inviteaction: "/mock/inviteaction.json",
        gkk_qaitem_answer_teacher: "/mock/gkk_qaitem_answer_teacher.json",
        deleteqaitem: "/mock/deleteqaitem.json",
        delete_answeritem: "/mock/delete_answeritem.json",

        // 发现是否有新消息
        discover_new: '/mock/discover_new.json',
        // 发现消息已阅
        discover_mark: '/mock/discover_new.json',

        // 我的课件、我的试卷、个人信息
        collection_list : "/mock/collection_list.json",
        deletecollection : "/mock/deletecollection.json",
        paper_list : "/mock/paper_list.json",
        deletepaper : "/mock/deletepaper.json",
        user_profile : "/mock/user_profile.json",
        // user_profile: "/v/course_meta/user_info",
        user_profile_edit : "/mock/user_profile_edit.json",
        //高校名称list
        school_name_query : "/mock/school_name_query.json",
        // 班级课程
        // mycourse: "/mock/mycourse.json",
        mycourse: "/v/course_meta/my_courses",
        //获取全部的课程列表——过滤归档班级的
        my_courses_top: '/v/course_meta/my_courses_top',
        edit_course: "http://apimock.xuetangx.com/mock/115/v/course_meta/edit_course",
        exitClassroom : "/mock/mycourse.json",
        create_course: "/mock/create_course.json",
        join_classroom : "http://apimock.xuetangx.com/mock/115/v/course_meta/join_classroom",
        manage_classroom_student:"http://apimock.xuetangx.com/mock/115/v/course_meta/manage_classroom_student",
        manage_student:"/mock/manage_student.json",
        manage_role:"/mock/manage_role.json",
        manage_role_collaborator:"http://apimock.xuetangx.com/mock/115/v/course_meta/manage_role_collaborator",
        manage_classroom_teachinglogs:"/mock/manage_classroom_teachinglogs.json",
        classroom_student_search: "http://apimock.xuetangx.com/mock/115/v/course_meta/classroom_student_search",
        select_collection:"/mock/select_collection.json",
        select_collection2classroom:"/mock/select_collection2classroom.json",
        select_paper:"/mock/select_paper.json",
        select_paper2classroom:"/mock/select_paper2classroom.json",
        learning_lesson_detail:"/mock/learning_lesson_detail.json",
        // learning_cards_detail:"/v/cards/learning_cards_detail",
        learning_cards_detail:"/mock/learning_cards_detail.json",
        student_ppt:"http://apimock.xuetangx.com/mock/115/v/lesson/show_studentsPPT",
        student_ppt_v3:"/mock/student_ppt_v3.json",
        cards_feedback_reply:"/mock/feedback_reply.json",
        cards_finished_list:"/mock/cards_finished_list.json",
        cards_viewer_list:"/mock/cards_viewer_list.json",
        teaching_cards_detail:"/mock/teaching_cards_detail.json",
        // teaching_cards_detail:"/v/cards/teaching_cards_detail",
        teacher_cards_answer_detail:"/mock/teacher_cards_answer_detail.json",
        // teacher_cards_answer_detail:"/v/cards/teacher_cards_problems_detail",
        teacher_quiz_detail:"/mock/teacher_quiz_detail.json",
        teacher_quiz_finish_list:"/mock/teacher_quiz_finish_list.json",
        teacher_quiz_checked_detail:"/mock/teacher_quiz_finish_list.json",
        teacher_quiz_answer_detail:"http://apimock.xuetangx.com/mock/115/v/quiz/teacher_quiz_problems_detail",
        teacher_quiz_score_detail:"/mock/teacher_quiz_score_detail.json",
        // teacher_quiz_detail:"/v/quiz/teacher_quiz_detail",
        // teacher_quiz_finish_list:"/v/quiz/quiz_finish_list",
        // teacher_quiz_checked_detail:"/v/quiz/quiz_checked_detail",
        // teacher_quiz_answer_detail:"/v/quiz/teacher_quiz_problems_detail",
        // teacher_quiz_score_detail:"/v/quiz/teacher_quiz_score_detail",
        teacher_PPT:"/mock/teacher_PPT.json",
        teacher_PPT_one:"/mock/teacher_PPT_one.json",
        teacher_slideproblem_detail:"/mock/teacher_slideproblem_detail.json",
        lesson_subjective_problem_result_list: "http://apimock.xuetangx.com/mock/115/v/lesson/subjective_problem_result_list/",
        subjective_problem_unfinished_list: "http://apimock.xuetangx.com/mock/115/v/lesson/subjective_problem_unfinished_list",
        subjective_problem_teacher_scorev2: "http://apimock.xuetangx.com/mock/115/v/lesson/subjective_problem_teacher_scorev2/",
        teacher_slideproblem_resultdetail:"/mock/teacher_slideproblem_resultdetail.json",
        lesson_detail_teacher_presentation:"http://apimock.xuetangx.com/mock/115/v/lesson/lesson_detail_teacher_presentation",
        config_presentation: "http://apimock.xuetangx.com/mock/115/v/lesson/config_presentation",
        web_ppt_config: "/pc/web_ppt_config",
        // 旁听生加入班级

        audit_classroom: "/mock/audit_classroom.json",

        // 课程小结 start
        teaching_lesson_detail: "http://apimock.xuetangx.com/mock/115/v/lesson/teaching_lesson_detail",
        teaching_lesson_detail_additional: "http://apimock.xuetangx.com/mock/115/v/lesson/teaching_lesson_detail_additional",
        lesson_problem_statistics: "http://apimock.xuetangx.com/mock/115/v/lesson/lesson_problem_statistics",
        teaching_lesson_rank: "/mock/teaching_lesson_rank.json",
        teaching_lesson_personal: "http://apimock.xuetangx.com/mock/115/v/lesson/teaching_lesson_student_score_detail",
        random_name_list: "/mock/random_name_list.json",
        lesson_not_participant_list: "http://apimock.xuetangx.com/mock/115/v/lesson/lesson_not_participant_list_new",
        teaching_lesson_members: "http://apimock.xuetangx.com/mock/115/v/lesson/teaching_lesson_participant_list_new/{lesson_id}",
        view_live_list: "/v/lesson/view_live_list",
        teaching_lesson_slides: "/mock/teaching_lesson_slides.json",
        teaching_lesson_slide_detail: "/mock/teaching_lesson_slide_detail.json",
        teaching_lesson_problems: "/mock/teaching_lesson_problems.json",
        teaching_lesson_problem_detail: "/mock/teaching_lesson_problem_detail.json",
        get_subj_result_score_detail: 'http://apimock.xuetangx.com/mock/115/v/lesson/get_subj_result_score_detail/',
        edit_subj_problem_score_proportion: 'http://apimock.xuetangx.com/mock/115/v/lesson/edit_subj_problem_score_proportion',
        // 课程小结 end
        lesson_danmu_detail:"/mock/lesson_danmu_detail.json",
        mystore:"/v/gkk/collection/mycollection",
        mystore_create_tag:"/mock/user_profile_edit.json",
        mystore_delete_tag:"/mock/user_profile_edit.json",
        //收藏中投稿标签增删
        mystore_create_tougao_tag:"/mock/user_profile_edit.json",
        mystore_delete_tougao_tag:"/mock/user_profile_edit.json",
        publish_paper:"/mock/publish_paper.json",
        publish_collection:"http://apimock.xuetangx.com/mock/115/v/course_meta/publish_collection2classroom/1/",
        message_task:"/mock/message_task.json",
        message_notice:"/mock/message_notice.json",
        message_notice_new: "/mock/message_notice.json",
        message_fans:"/mock/message_fans.json",
        message_mark:"/mock/message_mark.json",
        message_new:"/mock/message_new.json",
        // 小金库 start
        bank_balance: "/pay/inner",
        generate_order: "/pay/mp/order",
        // 小金库 end
        teacher_syreport:"/mock/teacher_syreport.json",
        teacher_syreport_batch:"/mock/teacher_syreport_batch.json",
        sy_data:"/mock/sy_data.json",
        teacher_sydetail:"/mock/teacher_sydetail.json",
        classroom_students:"/mock/classroom_students.json",
        members_profile:"/mock/members_profile.json",
        deletesy:"/mock/deletesy.json",
        platform_node:"/api/op/node_proxy",
        teacher_sydetail_reply:"/mock/teacher_sydetail_reply.json",
        student_sydetail:"/mock/student_sydetail.json",
        platform_exp_reminder:"/mock/message_mark.json",
        //专业版身份绑定
        pro_getBindSchool: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_university_info/',
        bind_user_number:"/mock/pro_toBindSchool.json",
        // unbind_user_number: "/mock/pro_toBindSchool.json",
        get_verify_info:"/mock/get_verify_info.json",
        get_verify_code:"/mock/get_verify_code.json",
        get_cas_university_bind_hint: "http://apimock.xuetangx.com/mock/131/edu_admin/get_cas_university_bind_hint/",
        // pro_getBindSchool:"/edu_admin/get_university_info/",
        // bind_user_number:"/edu_admin/bind_user_number/",
        unbind_user_number:"/edu_admin/unbind_user_number/",
        // get_verify_info:"/edu_admin/verify/get_verify_basic_info/",
        // get_verify_code:"/edu_admin/verify/get_verify_code/",
        // get_cas_university_bind_hint: "/edu_admin/get_cas_university_bind_hint/",
        //学生小结
        learning_lesson_detail_v2:"http://apimock.xuetangx.com/mock/115/v/lesson/learning_lesson_detail_v2",
        learning_lesson_detail_v3:"/mock/learning_lesson_detail_v3.json",
        // learning_lesson_detail_v2:"/mock/learning_lesson_detail_v2.json",
        // learning_lesson_detail_v2:"/v/lesson/learning_lesson_det ail_v2",
        //教师查看投稿
        // teacher_tougao_list:"/mock/tougao_list.json",
        teacher_tougao_list: '/v/api/tougao/teacher/list',
        teacher_tougao_collect:"/mock/tougao_list.json",
        teacher_tougao_collect_cancel:"/mock/tougao_list.json",
        // student_tougao_list:"/mock/tougao_list.json",
        student_tougao_list: "/v/api/tougao/student/list",
        student_tougao_list_v3:'/mock/student_tougao_list_v3.json',
        //预约发布
        // publish_appointment: "/v/course_meta/publish_appointment/",
        publish_appointment: "http://apimock.xuetangx.com/mock/115/v/course_meta/publish_appointment/",
        delete_publish_appointment: "/mock/delete_publish_appointment.json",
        edit_publish_appointment: "/mock/edit_publish_appointment.json",

        // 异步创建发布课件或试题
        async_publish_appointment: "/v/course_meta/async_publish_appointment/",
        // 创建发布课件或试题后轮询进度
        publish_appointment_schedule: "/v/course_meta/publish_appointment_schedule/",

        get_export_activities:"/mock/get_export_activities.json?",
        generate_data_export:"/mock/get_export_activities.json",
        get_event_extra_info:"/mock/get_event_extra_info.json?",
        query_export_task_state:"/mock/get_export_activities.json?",
        //群发公告
        publish_notice:"/mock/publish_notice.json?",
        topublish_notice:"/mock/publish_notice.json?",
        topublish_notice_v2:"/v/discussion/v2/topics/",
        notice_view:"/mock/notice_view.json?",
        notice_view_notice_up:'http://apimock.xuetangx.com/mock/619/v/discussion/v2/announcement/{id}/',
        forum_top:'http://apimock.xuetangx.com/mock/619/v/discussion/v2/topic/{forum_id}/top/',
        delete_notice:"/mock/publish_notice.json?",
        notice_ready_static:"/mock/notice_ready_static.json?",

        //是否需要签署诚信协议
        class_agreement: "/c27/online_courseware/classroom_agreement/detail/",
        //签署协议
        sign_class_agreement: '/c27/online_courseware/classroom_agreement/sign/',
        //修改头像
        edit_user_avatar:"/mock/notice_ready_static.json",

        // 习题集

        // 习题集课程列表
        problemset_course_list: "http://apimock.xuetangx.com/mock/115/v/problem/my_problem_list",
        // 课程活动列表
        problemset_course_activities: "http://apimock.xuetangx.com/mock/115/v/problem/all_problem_list",
        // 课程活动错误列表
        problemset_error_problems: "http://apimock.xuetangx.com/mock/115/v/problem/error_problem_list",
        // 课程活动加星问题列表
        problemset_star_problems: "http://apimock.xuetangx.com/mock/115/v/problem/star_problem_list",

        // 活动问题列表
        problemset_cards_problems: "http://apimock.xuetangx.com/mock/115/v/problem/cards_problem_list",
        problemset_lesson_problems: "http://apimock.xuetangx.com/mock/115/v/problem/lesson_problem_list",
        problemset_quiz_problems: "http://apimock.xuetangx.com/mock/115/v/problem/quiz_problem_list",

        // 问题收藏
        problemset_add_star: "http://apimock.xuetangx.com/mock/115/v/problem/add_star",
        problemset_cancel_star: "http://apimock.xuetangx.com/mock/115/v/problem/cancel_star",

        // 问题记录笔记
        problemset_add_note: "http://apimock.xuetangx.com/mock/115/v/problem/add_modify_note",

        // 教师查看课件详情
        teacher_cards_detail: "http://apimock.xuetangx.com/mock/115/v/cards/cards_detail_teacher_slides/",

        //设置语言
        set_lang_en: "/mock/set_lang_en.json",
        set_lang_zh_cn: "/mock/set_lang_zh_cn.json",

        // 讨论区帖子
        get_post: "http://apimock.xuetangx.com/mock/115/v/discussion/one_topic_fetch",
        reply_post: "http://apimock.xuetangx.com/mock/115/v/discussion/reply_create_with_post",
        get_post_comments: "http://apimock.xuetangx.com/mock/115/v/discussion/comment_fetch",
        get_post_comment: "http://apimock.xuetangx.com/mock/115/v/discussion/one_comment_fetch",
        do_digg: "http://apimock.xuetangx.com/mock/115/v/discussion/like_up",
        cancel_digg: "http://apimock.xuetangx.com/mock/115/v/discussion/like_cancel",
        get_digg_list: "http://apimock.xuetangx.com/mock/115/v/discussion/like_user_lis",
        del_post: "http://apimock.xuetangx.com/mock/115/v/discussion/topic_delete",
        // 删除评论和评论回复
        del_post_reply: "http://apimock.xuetangx.com/mock/115/v/discussion/reply_delete",

        //新教学日志
        classroom_logs: "http://apimock.xuetangx.com/mock/115/v/course_meta/classroom_logs",
        // classroom_logs: "/v/course_meta/classroom_logs",
        manage_teaching_activity: "http://apimock.xuetangx.com/mock/115/v/course_meta/manage_teaching_activity",  //老接口测试
        check_permission_manage_teaching_activity: "/v/course_meta/check_permission_manage_teaching_activity",  //检查协同教师权限的老接口
        on_lesson_courses: "/v/course_meta/on_lesson_courses",     //正在上课
        get_upcoming_exam: "/v/rain_exam/get_upcoming_exam/",  // 正在进行的考试
        send_mails_to_teacher: "http://apimock.xuetangx.com/mock/115/send_mails_to_teacher", // 发送数据到邮箱
        get_reset_leaf: "/mooc-api/v1/lms/learn/course/reset_leaf", //获取重置作业时间
        get_classroom_info: "/v2/api/web/classrooms", //获取班级信息
        on_lesson_upcoming_exam: "/api/v3/classroom/on-lesson-upcoming-exam",  // 获取正在上的班级以及即将开始的考试

        //课件、试卷文件夹
        own_collections:"http://apimock.xuetangx.com/mock/115/v/cards/own_collections",
        learned_cards:"http://apimock.xuetangx.com/mock/115/v/cards/learned_cards",
        // own_papers:"http://apimock.xuetangx.com/mock/115/v/quiz/own_papers",
        // learned_quiz:"http://apimock.xuetangx.com/mock/115/v/quiz/learned_quiz",
        own_papers:"/v/quiz/own_papers",
        learned_quiz:"/v/quiz/learned_quiz",
        change_directory:"http://apimock.xuetangx.com/mock/115/api/cop/change_directory",


        //讨论区
        // post_dicssuion: "http://apimock.xuetangx.com/mock/115/v/discussion/topic_create",
        // discussion_topic_fetch: "http://apimock.xuetangx.com/mock/115/v/discussion/classroom_topic_fetch",
        // discussion_like_up: "http://apimock.xuetangx.com/mock/115/v/discussion/like_up",
        // discussion_like_cancel: "http://apimock.xuetangx.com/mock/115/v/discussion/like_cancel",
        // topic_edit: "http://apimock.xuetangx.com/mock/115/v/discussion/topic_edit",
        // activity_topic_create: "http://apimock.xuetangx.com/mock/115/v/discussion/activity_topic_create",

        // 讨论区替换成学堂云
        post_dicssuion: "/v/discussion/v2/topics/",
        discussion_topic_fetch: "/v/discussion/v2/topics/",
        topic_liked: "/v/discussion/v2/topic/{topic_id}/liked/",
        comment_liked: "/v/discussion/v2/comment/{comment_id}/liked/",
        get_comment_list: "/v/discussion/v2/comment/list/{topic_id}/",
        get_comment_detail: "/v/discussion/v2/topic/detail/{topic_id}/",
        get_replys_list: "/v/discussion/v2/reply/list/{comment_id}/",
        get_comment: "/v/discussion/v2/comment/",
        send_comment: "/v/discussion/v2/comment/",
        reply_comment: "/v/discussion/v2/reply/comment/",
        reply_replay: "/v/discussion/v2/reply/reply/",
        reply_list: "/v/discussion/v2/reply/list/{reply_id}/",
        del_topic: "/v/discussion/v2/topic/{topic_id}/",
        del_comment: "/v/discussion/v2/comment/",
        del_reply: "/v/discussion/v2/reply/reply/",
        get_topic_liked: "/v/discussion/v2/topic/liked/users/",
        get_comment_liked: "/v/discussion/v2/comment/liked/users/",

        // 私信相关
        get_user: "http://apimock.xuetangx.com/mock/115/v/course_meta/fetch_user_info",
        get_user_new: "http://apimock.xuetangx.com/mock/115/v/course_meta/fetch_user_info_new",
        get_users_avatar: "/v2/api/web/userinfo",
        test: "",

        // 预习详情页支持查看每个学生习题总得分
        cards_status_list: 'http://apimock.xuetangx.com/mock/115/v/cards/cards_status_list',
        // cards_status_list: '/v/cards/cards_status_list',
        // 预习详情页支持查看单个学生详情
        student_cards_detail: 'http://apimock.xuetangx.com/mock/115/v/cards/student_cards_detail',
        // student_cards_detail: '/v/cards/student_cards_detail',
        // 教师试卷详情页支持查看每个学生答卷情况
        teacher_quiz_result_list: 'http://apimock.xuetangx.com/mock/115/v/quiz/teacher_quiz_result_list',
        // teacher_quiz_result_list: '/v/quiz/teacher_quiz_result_list',
        // 教师试卷详情页支持查看每个学生答卷情况-学生详情
        student_quiz_detail: 'http://apimock.xuetangx.com/mock/115/v/quiz/student_quiz_detail',
        // student_quiz_detail: '/v/quiz/student_quiz_detail',
        //获取用户当前语言设置
        get_current_language: "http://apimock.xuetangx.com/mock/115/v/user/get_current_language",
        // 获取实验详情
        web_get_event_detail: "http://apimock.xuetangx.com/mock/115/api/op/web_get_event_detail/",

        // 截屏列表
        get_screenshot_list: "http://apimock.xuetangx.com/mock/115/v/lesson/file_sharing/get_lesson_share_list/",
        get_screenshot_list_v3: "/mock/file_sharing.json",

        // 直播回放
        // get_lesson_timeline: "http://apimock.xuetangx.com/mock/115/v/lesson/get_lesson_replay_timeline/",
        get_lesson_timeline: "/mock/get_lesson_replay_timeline2.json",
        get_lesson_info: "/mock/get_lesson_replay_content2.json",
        // get_lesson_info: "http://apimock.xuetangx.com/mock/115/v/lesson/get_lesson_replay_content/",
        get_board_track: "/mock/get_board_track.json",
        // get_board_data: "http://apimock.xuetangx.com/mock/115/v/lesson/file_sharing/get_board_track",
        // get_lesson_timeline: "/v/lesson/get_lesson_replay_timeline/",
        // get_lesson_info: "/v/lesson/get_lesson_replay_content/",
        // 学生观看回放
        view_live: "http://apimock.xuetangx.com/mock/115/v/lesson/view_live",

        // 删除直播记录
        delete_live: 'http://apimock.xuetangx.com/mock/115/v/lesson/live/delete',
        // 查询是否有转存权限
        get_permissions: 'http://apimock.xuetangx.com/mock/747/api/open/plug/audiovideo/permissions',
        // 查询用户的空间大小
        get_user_space: 'http://apimock.xuetangx.com/mock/131/api/open/yunpan/userspace/detail',
        // 转存回放段落
        save_live: 'http://apimock.xuetangx.com/mock/131/api/open/yunpan/lesson/live/save-as',
        // 获取直播回放下载地址
        download_live: '/v/lesson/live/download',
        // 获取是否是会员
        get_vip_status: '/v/course_meta/vip/',
        // 返回云盘使用权限
        get_cloud_permission: '/api/open/yunpan/lesson/live/permission',

        // 停服务通知
        hole_service_notice: "http://apimock.xuetangx.com/mock/115/pc/hole_service_notice/",
        // 手机号绑定强制弹窗条件判断
        force_bind_status: "http://apimock.xuetangx.com/mock/115/pc/force_bind_status",
        // 是否已绑定手机号
        is_bind_phone: "http://apimock.xuetangx.com/mock/115/pc/is_bind_phone",
        // 用户绑定手机号
        bind_phone: "http://apimock.xuetangx.com/mock/115/pc/bind_phone",
        // 发送短信验证码接口
        send_sms_code: "http://apimock.xuetangx.com/mock/115/pc/send_sms_code",

        // 新的钱包充值提现接口
        payment_proxy: '/v/payment/node_proxy',

        // h5,小程序,新web-获取阅读并同意用户内容版权协议
        get_agreement: '/train_platform/v1/rain-user/agreement/',
        set_agreement: '/train_platform/v1/rain-user/agreement/',

        // 学生表现页接口
        behavior_tag: {
            // 学生课堂表现加分备注页
            student_about: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/student_about",
            // 修改学生的签到状态
            change_participate: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/change_participate",
            // 修改学生的表现加分值
            change_score: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/change_score",
            // 搜索学生
            search_classroom_student: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/search_classroom_student",
            // 新增标签
            create_tag: 'http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/created',
            // 给学生添加标签
            bind_student: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/bind_student",
            // 老师删除标签
            deleted_tag: "http://apimock.xuetangx.com/mock/115/v/lesson/behavior_tag/deleted"
        },

        // 学生课后小结取消/收藏课件
        // post_studentlessonslide_tag: "http://apimock.xuetangx.com/mock/115/v/lesson/post_studentlessonslide_tag",
        post_studentlessonslide_tag: "/v/lesson/post_studentlessonslide_tag",
        post_studentlessonslide_tag_v3: "/mock/post_studentlessonslide_tag_v3.json",

        // 通用账号密码设置
        user_account_setting: {
            // 【通用】获取用户账号设置状态
            get_user_bind_status: "http://apimock.xuetangx.com/mock/115/pc/register/get_user_bind_status/",
            // get_user_bind_status: "/pc/register/get_user_bind_status/",
            // 【邮箱】绑定邮箱
            bind_email: "http://apimock.xuetangx.com/mock/115/pc/register/bind_email/",
            // bind_email: "/pc/register/bind_email/",
            // 【邮箱】发送绑定邮箱验证码
            send_email_code: "http://apimock.xuetangx.com/mock/115/pc/register/send_email_code/",
            // send_email_code: "/pc/register/send_email_code/",
            // 设置密码
            set_password: "http://apimock.xuetangx.com/mock/115/pc/register/set_password/",
            // set_password: "/pc/register/set_password/",
            // 【加密】获取密码加密公钥
            get_pws_public_key: "/pc/register/get_pws_public_key/",
            // 是否已绑定手机号
            is_bind_phone: "/pc/is_bind_phone",
            // 用户绑定手机号
            bind_phone: "/pc/bind_phone",
            // 发送短信验证码接口
            send_sms_code: "/pc/send_sms_code",
            // 发送手机验证码登录验证码-----用于忘记密码中获取验证码 || 【手机登录】发送手机验证码登录验证码
            send_sms_login_code: "/pc/login/send_sms_login_code/",
            // 验证短信验证码是否正确
            verify_sms_code: "/pc/verify_sms_code/",
            // 通用登录】邮箱/手机号密码登录+手机号验证码登录
            verify_pwd_login: "/pc/login/verify_pwd_login/",
            // 忘记密码重新设置密码
            set_forgotten_password: "/pc/set_forgotten_password/",
            // 新的绑定+校验接口（Java）
            check_phone_number_bind: "/api/v3/user/check-phone-number-bind",
            update_phone_number: "/api/v3/user/update-phone-number",
            // 账号合并
            merge_account: '/api/v3/user/mergeAccount',
            // 获取选课列表
            get_all_course_list: "/v/course_meta/all_course_list",
            bind_email_for_user: "/pc/register/bind_email_for_user/",
        },
        // 行政通知
        notice: {
            // get获取用户已发布的行政通知列表
            "get_notice_list": "/edu_admin/admin_notice/list/",
            // 获取可选择发送范围
            "get_notice_area": "/edu_admin/admin_notice/areas/",
            // 根据选择发送范围获取发送人员名单
            "get_notice_users": "/edu_admin/admin_notice/users/",
            // 保存行政通知并处于预发布/预审核状态
            "post_notice_info": "/edu_admin/admin_notice/save/",
            // 编辑行政通知
            "edit_notice_info": "/edu_admin/admin_notice/edit/",
            // 生成或者刷新二维码
            "get_notice_qrcode": "/edu_admin/admin_notice/qr_code/",
            // 发布行政通知
            "post_notice_publish": "/edu_admin/admin_notice/publish/",
            // 查看行政通知
            "get_notice_publish": "/edu_admin/admin_notice/detail/",
            // 删除行政通知
            "delete_notice_publish": "/edu_admin/admin_notice/delete/",
            // 设置审核信息
            "post_notice_setting": "/edu_admin/admin_notice/settings/",
            // 轮询用户是否扫码成功
            "get_notice_scan": "/edu_admin/admin_notice/check_scan/",
            // 审核通知
            "post_notice_audit": "/edu_admin/admin_notice/audit/",
        },
        // 课程设置页
        course_setting: "/v/course_meta/v2/course/setting",
        // 课程简介
        course_intro: "/v/course_meta/v2/course/intro",
        // 编辑课程
        course_edit: "/v/course_meta/v2/course/edit",
        // 编辑班级
        classroom_edit: "/v/course_meta/v2/classroom/edit",
        // 删除课程提示
        course_del_confirm: "/v/course_meta/v2/course/del_confirm",
        // 删除班级确认
        classroom_del_confirm: "/v/course_meta/v2/classroom/del_confirm",
        // 删除班级
        classroom_delete: "/v/course_meta/v2/classroom/delete",
        // 归档班级
        archive_classroom: "/v/course_meta/archive_course",
        // 取消归档操作
        cancel_archive_course: '/v/course_meta/cancel_archive_course',
        // 删除课程
        course_delete: "/v/course_meta/delete_course",
        // 创建班级
        classroom_create: "/v/course_meta/v2/classroom/create",
        // 班级设置页
        classroom_setting: "/v/course_meta/v2/classroom/setting",

        // 清华校友会发起绑定
        taaStart: "http://apimock.xuetangx.com/mock/131/taa/start",
        // 清华校友会轮训绑定状态
        taaPolling: "http://apimock.xuetangx.com/mock/131/taa/polling",

        // 成员管理新接口
        member_manage: {
            // 查询班级的主讲老师、协助老师、助教列表
            "teacher_assistants": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/teacher_assistants",
            // 分页查询班级的学生信息
            "page_students": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/page-students",
            // 查看班级用户个人信息
            "user_info": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/user-info",
            // 根据学号或姓名模糊搜索班级的学生信息
            "search_students": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/search-students",
            // 邀请学生-查看班级二维码
            "classroom_barcode": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/classroom-barcode",
            // 编辑学生的班级名片信息
            "classroom_card": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/change/classroom-card",
            // 查询班级的黑名单
            "blacklist": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/blacklist",
            // 删除班级学生
            "remove_student": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/remove-student",
            // 批量加入黑名单
            "join_blacklist": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/join-blacklist",
            // 删除班级成员
            "removed": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/removed",
            // 提拔班级用户的班级身份
            "promoted": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/promoted",
            // 降级班级用户的班级身份
            "demoted": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/demoted",
            // 添加班级用户
            "add": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/add",
            // 批量解除黑名单
            "remove_blacklist": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/remove-blacklist",
            // 查看班级用户班级身份
            "classroom_role": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/classroom-role",
            // 基础版本搜索班级用户信息（老师、助教、学生）
            "basic_search_members": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/basic-search-members",
            // 分页查询班级的用户信息，比如协同等
            "page_members": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/page-members",
            // 查询班级信息
            "classroom_info": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/classroom-info",
            // 查询当前用户角色
            "member_classroom_role": "http://apimock.xuetangx.com/mock/115/api/open/classroom/member/classroom-role",
        },

        // 新试卷封面页接口
        examcover: {
            // 试卷封面
            cover: "/v/exam/cover",
            // 获取跳转token
            get_tocken: "/v/exam/gen_token",
            // 结课后是否能继续学习
            classroom_extra_info: '/v/course_meta/v2/classroom/extra-info',
        },
        // 考试小结
        exam: {
            // 获取班级信息
            classroom_info: '/v/course_meta/classroom_info',
            basic: "http://apimock.xuetangx.com/mock/675/v/exam/stats/basic",
            distribution: "http://apimock.xuetangx.com/mock/675/v/exam/stats/distribution",
            users: "http://apimock.xuetangx.com/mock/675/v/exam/stats/user",
            //用户密码校验
            vertify_password: '/c27/api/exam/verify_publish_exam_password/',
        },
        // 学校绑定
        mystoreAllApi: {
            sms_code: 'http://apimock.xuetangx.com/mock/131/edu_admin/account/bind/login/sms_code', // 发送验证码
            bind_sms: 'http://apimock.xuetangx.com/mock/131/edu_admin/account/bind/login/sms', // 手机号绑定
            register_sms_code: '/edu_admin/account/register/sms_code',
            register_phone: '/edu_admin/account/register/phone',
            //清华比赛--注册账号--学校列表
            external_university_list:"/train_platform/v1/external_university_list/",
            get_university_info: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_university_info/',
            get_all_env_uv_list: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_all_env_uv_list/',
            tempqrcode: 'http://apimock.xuetangx.com/mock/115/wechat/wxapi/tempqrcode',
            get_uv_qrcode: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_uv_qrcode/', // {uv_id}/{env}
            get_user_phone_number: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_user_phone_number/',
            bind_user_number_add_info: 'http://apimock.xuetangx.com/mock/131/edu_admin/bind_user_number_add_info/',
            get_one_university_info: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_one_university_info/',
            get_user_info: 'http://apimock.xuetangx.com/mock/131/edu_admin/get_user_info/',
            send_code: '/edu_admin/account/bind/login/send_code',
            bind_by_code: '/edu_admin/account/bind/login/code',
            // k12相关
            k12_check_user: '/edu_admin/check_k12user_number/',
            k12_bind_user: '/edu_admin/bind_k12user_number/',
            k12_verify_children: '/edu_admin/account/register/weixin/verify-children',
            k12_register_parent: '/edu_admin/account/register/weixin/bind-children',
            k12_get_school_platform:'/edu_admin/parents/children/weixin/school-platform/',
        },

        // 成绩单相关
        transcript: {
            get_status: '/v/course_meta/transcript/classroom/open/status',
            get_tags: '/v/course_meta/all/etag'
        },
        // 云雨教学活动打通
        cloud: {
            // 获取章节批量发布动态详情
            get_pub_news: '/c27/online_courseware/xty/kls/pub_news/{news_id}/',
            // 章节叶子节点详情
            get_leaf_info: '/mooc-api/v1/lms/learn/leaf_info/{classroom_id}/{leaf_id}/',
            leaf_level_info: "/edu_admin/leaf_level_info/",
        },
        teacher_v3: {
            lesson_summary_teacher: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/teacher', // 课后小结-基本信息
            lesson_summary_teacher_students: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/teacher/students', // 课后小结-学生列表
            update_presentation_config: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/update-presentation-config', // （老师）课后更改设置PPT查看范围
            update_config: 'http://apimock.xuetangx.com/mock/872/api/v3/user/update-config', // TODO: 全局设置PPT查看范围
            teacher_presentation: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/teacher/presentation', // （老师）课后小结-课件信息
            on_lesson_courses: 'http://apimock.xuetangx.com/mock/872/api/v3/classroom/on-lesson', // 正在上课
            subj_list: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/subj-list',  // 主观题列表
            subj_result_list: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/subj-result-list', // （老师）主观题回答列表
            subj_grade: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/subj-grade', // 主观题打分
            danmu: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/danmu', // 弹幕列表
            tougao: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/tougao', // 投稿列表
            roll: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/roll', // 随机点名列表
            file_sharing: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/file-sharing', // 截图分享分享
            collect: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/tag', // 课下不懂收藏
            student_info: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/student-info', // 学生课堂表现详情
            assess_student_about: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-assess/student/about', // 学生课堂表现加分和标签
            assess_score_changed: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-assess/score/changed', // 学生课堂表现加分变更
            assess_tag_created: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-assess/tag/created', // 学生课堂表现老师添加标签
            assess_tag_bind_student: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-assess/tag/bind_student', // 学生课堂表现老师变更选中标签
            assess_tag_deleted: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-assess/tag/deleted', // 学生课堂表现老师删除标签
            teacher_checkin: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/checkin', // 课下修改学生签到状态
            fetch_student_detail: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/student/detail', // 获取学生跟人详情
            problem_histogram: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/problem-histogram', // 客观题柱状图数据、红包列表
            problem_choice_detail: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/problem-choice-detail', // 客观题选项选择分布
            fill_blank_result: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/fill-blank-result', // 填空题学生信息以及作答详情
            regrade_blank: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/regrade-blank', // 填空题改判

        },
        student_v3: {
            lesson_summary_student: 'http://apimock.xuetangx.com/mock/872/api/v3/lesson-summary/student', // 课后小结-基本信息
            // 视频打点
            heartbeat: '/video-log/heartbeat/'
        },
        evaluation_list: 'http://apimock.xuetangx.com/mock/904/api/evaluation/teaching/universities',
        redirectToEvaluation: '/api/evaluation/teaching/redirectTo',
        getCheckSetUpEvaluation: "/api/evaluation/teaching/checkSetUpEvaluation",
        // 账号注销-查询
        get_account_status: '/pc/get_close_account_info',
        // 账号注销-撤回
        cancel_close_account: "/pc/cancel_close_account",
        // 师德师风承诺书
        get_user_apply_judge: '/train_platform/v1/cert/user_apply_judge/',
        get_cert_user_info: '/train_platform/v1/cert/user_tc8/info/',
        get_discovery_link: '/c27/online_courseware/find_page_link/',
        graph_convert: '/c27/online_courseware/instance/graph/convert/',
        get_graph_menu: '/mooc-api/v1/lms/kg/student_learn_chapter/',
        knowledge_graph_jump_leaf: '/train_platform/v1/knowledge_graph/{graph_id}/jump_leaf/{classroom_id}/',
    }
}

export default api



// WEBPACK FOOTER //
// ./src/util/api.js